export default __webpack_public_path__ + "static/media/land-3.83892a79.mp4";